import util from '@bmp-vue/core/api/util'
import Axios from 'axios'

const controller = 'Dbs'
const getToken = () => JSON.parse(localStorage.getItem('user'))?.token;
const url = process.env.VUE_APP_ROOT_API + controller

export default Object.assign({}, util.GetCrud(controller, ['none']), {
  PostFile: function (dto, disableLoading) {
    const request = { ...dto }
    const headers = { Authorization: `Bearer ${getToken()}` }
    disableLoading ?? util.store.commit('addRequest')
    return Axios.post(`${url}/UploadArquivo`, request, { headers }).then(util.ResponseFunctions.HandleResponseBase, util.ResponseFunctions.HandleError)
  },
  Post: function (acao, dto, disableLoading) {
    var request = { Dto: dto, Acao: acao }
    const headers = { Authorization: `Bearer ${getToken()}` }
    disableLoading ?? util.store.commit('addRequest')
    return Axios.post(`${url}/Post`, request, { headers }).then(util.ResponseFunctions.HandleResponseBase, util.ResponseFunctions.HandleError)
  },

  Put: function (acao, id, dto, disableLoading, queryParameters) {
    var request = { Dto: dto, Acao: acao }
    const headers = { Authorization: `Bearer ${getToken()}` }
    const paramsUrl = new URLSearchParams({
      ...(queryParameters && { queryParameters: JSON.stringify(queryParameters) })
    })
    disableLoading ?? util.store.commit('addRequest')
    return Axios.put(`${url}/Put/${id}${queryParameters ? '?' + paramsUrl : ''}`, request, { headers }).then(util.ResponseFunctions.HandleResponseBase, util.ResponseFunctions.HandleError)
  },
  Get: function (path, queryParameters, disableLoading) {
    const paramsUrl = new URLSearchParams({
      path: path,
      ...(queryParameters && { queryParameters: JSON.stringify(queryParameters) })
    })
    const headers = { Authorization: `Bearer ${getToken()}` }
    disableLoading ?? util.store.commit('addRequest')
    return Axios.get(`${url}/Get?${paramsUrl}`, { headers }).then(util.ResponseFunctions.HandleResponseBase, util.ResponseFunctions.HandleError)
  },
  Delete: function (path, queryParameters, disableLoading) {
    const paramsUrl = new URLSearchParams({
      path: path,
      ...(queryParameters && { queryParameters: JSON.stringify(queryParameters) })
    })
    const headers = { Authorization: `Bearer ${getToken()}` }
    disableLoading ?? util.store.commit('addRequest')
    return Axios.delete(`${url}/Delete/?${paramsUrl}`, { headers }).then(util.ResponseFunctions.HandleResponseBase, util.ResponseFunctions.HandleError)
  },
  EnviarTokenNumerico: function (acao, dtoToken, isReenvio, dto) {
    var request = { DtoToken: { Ambiente: window.env.VUE_APP_AMBIENTE, ...dtoToken }, Acao: acao, ...(isReenvio && { isReenvio }), dto }
    const headers = { Authorization: `Bearer ${getToken()}` }
    return Axios.post(`${url}/EnviarTokenNumerico`, request, { headers }).then(util.ResponseFunctions.HandleResponseBase, util.ResponseFunctions.HandleError)
  },
  ValidarTokenNumerico: function (acao, dtoToken, dto) {
    var request = { DtoToken: { Ambiente: window.env.VUE_APP_AMBIENTE, ...dtoToken }, Acao: acao, dto }
    const headers = { Authorization: `Bearer ${getToken()}` }
    return Axios.post(`${url}/ValidarTokenNumerico`, request, { headers }).then(util.ResponseFunctions.HandleResponseBase, util.ResponseFunctions.HandleError)
  },
  AssinarAceiteTermo: function (dto) {
    var request = { ...dto }
    const headers = { Authorization: `Bearer ${getToken()}` }
    return Axios.post(`${url}/AssinarAceiteTermo`, request, { headers }).then(util.ResponseFunctions.HandleResponseBase, util.ResponseFunctions.HandleError)
  },
  GetTermoAceite: function (id) {
    return util.Axios.Get(
      `${controller}/GetTermoAceite?codigoIntegracaoDbs=${id}`
    )
  },
  GetParamIb: function () {
    return util.Axios.Get(controller + '/GetParamIb', window.env.VUE_APP_AMBIENTE)
  },
  UploadDocumentos: function (formData) {
    util.store.commit('addRequest')
    const headers = {
      Authorization: `Bearer ${getToken()}`,
      'Content-Type': 'multipart/form-data'
    }
    return Axios.post(`${url}/UploadArquivos`, formData, { headers }).then(util.ResponseFunctions.HandleResponseBase, util.ResponseFunctions.HandleError)
  },
  DeleteArquivo: function (file) {
    util.store.commit('addRequest')
    const headers = {
      Authorization: `Bearer ${getToken()}`
    }
    return Axios.delete(`${url}/DeleteArquivo`, { headers, data: file }).then(util.ResponseFunctions.HandleResponseBase, util.ResponseFunctions.HandleError)
  }
})
